<template>
    <div class="flex my-2">
        <Divider>
            <div class="flex sm:flex-nowrap">
                <div>
                    <Button :id="keyId" :icon="buttonIcon" class="p-button-rounded text-white mr-3" :class="[displayFlag ? 'p-button-warning' : 'p-button-danger']" @click="switchArrow" />
                </div>
                <Dropdown id="selector" v-model="selectedOption" :options="getAllLogicalOperations()" optionLabel="name" optionValue="name" placeholder="Select a logical operation" class="w-full md:w-14rem mr-2" @change="updateSelectedValue" />
            </div>
        </Divider>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps, computed, watch } from 'vue';

import { getAllLogicalOperations } from '../enum-helpers';
import { useDataSourceStore } from '../store';

const dataSourceStore = useDataSourceStore();

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
    },
    linkKey: {
        type: String,
    },
    displayFlag: {
        type: Boolean,
    },
});

// computed properties
const propsValue = computed(() => {
    return props.modelValue;
});

const keyId = computed(() => {
    return props.linkKey;
});

const buttonIcon = computed(() => {
    const iconface = props.displayFlag ? 'pi-chevron-down' : 'pi-chevron-right';
    return `pi ${iconface} `;
});

const selectedOption = ref(null);
// to check props updates
watch(propsValue, () => {
    selectedOption.value = propsValue.value;
    updateSelectedValue();
});

onMounted(() => {
    if (props.modelValue) {
        selectedOption.value = props.modelValue;
        updateSelectedValue();
    }
});

// actions
const updateSelectedValue = () => {
    emit('update:modelValue', selectedOption.value);
};

const switchArrow = () => {
    // console.log(`Switching key ${keyId.value} to ${arrowDown.value}`);
    // update the display in state as well
    dataSourceStore.toggleDisplayInConnector(keyId.value, props.displayFlag);
};
</script>
